import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import CriarForecastView from './CriarForecastView';
import AcompanhamentoForecastView from './AcompanhamentoForecastView';

function Forecast() {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}/criar`} exact component={CriarForecastView} />
            <Route path={`${match.path}/acompanhamento`} exact component={AcompanhamentoForecastView} />
            <Redirect path="*" to={`${match.path}/acompanhamento`} />
        </Switch>
    );
}

export default Forecast;
